import { useMemo, useState } from 'react'
import { DefaultTheme } from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import UnlimitedProlongingAdvantagesModal from 'components/global/UnlimitedProlongingAdvantagesModal'
import Link from 'components/shared/Link'

interface AdvantagesPointWithDetailsProps {
    text: string | undefined
    cardIndex: number
    isCardUnlimitedPlus: boolean
    theme?: DefaultTheme
}

const AdvantagesPointWithDetails = ({
    text,
    cardIndex,
    isCardUnlimitedPlus,
    theme,
}: AdvantagesPointWithDetailsProps) => {
    const [isModalOpened, setIsModalOpened] = useState(false)

    const handleModalOpen = () => setIsModalOpened(true)

    const pointText = useMemo(() => {
        const regex = /(.*?)<button [^>]+>(.*?)<\/button>/g
        const search = regex.exec(text || '')
        const mainText = search && search.length > 1 ? search[1] : ''
        const buttonText = search && search.length > 1 ? search[2] : ''

        return (
            <Text
                variant="body"
                color={
                    theme?.mode === 'dark' ? 'grayscale_200' : 'grayscale_900'
                }
            >
                {mainText}
                <Link
                    variant="primary"
                    textVariant="body"
                    isUnderlined
                    icon={null}
                    onClick={handleModalOpen}
                    theme={theme}
                    data-testid={`unlimited-${cardIndex}-button-renew-advantages${
                        isCardUnlimitedPlus ? '-plus' : ''
                    }`}
                >
                    {buttonText}
                </Link>
            </Text>
        )
    }, [text])

    return (
        <Box>
            <Text variant="body" color="grayscale_900">
                {pointText}
            </Text>
            <UnlimitedProlongingAdvantagesModal
                isOpened={isModalOpened}
                handleModalOpened={setIsModalOpened}
            />
        </Box>
    )
}

export default AdvantagesPointWithDetails
